export const DEFINE_USUARIOS = 'DEFINE_USUARIOS'
export const USUARIO_LOGADO = 'USUARIO_LOGADO'
export const DEFINE_COBRANCAS = 'DEFINE_COBRANCAS'